import firebase from "../firebase/Config";
import { Timestamp } from "firebase/firestore";
import { ref, uploadBytesResumable, getMetadata } from "firebase/storage";

/**
 * Uploads a file to Firebase Storage with a timestamped filename.
 * @param file - The file to be uploaded.
 * @returns A promise that resolves to the download URL or an error message.
 */
export const uploadFileWithTimestamp = async (file: File, key: string): Promise<{ success: boolean; url?: string; error?: string }> => {
  try {
    // Extract file extension
    const fileExtension = file.name.split('.').pop();
    
    // Generate new filename with timestamp
    const timestamp = Timestamp.now().nanoseconds;
    const newFileName = `${key}-${timestamp}.${fileExtension}`;
    const storagePath = `UserDataUpload/${newFileName}`;

    // Create storage reference
    const storageRef = ref(firebase.storage, storagePath);
    const uploadTask = uploadBytesResumable(storageRef, file);

    return new Promise((resolve) => {
      uploadTask.on(
        'state_changed',
        null,
        (error) => {
          console.error('Upload failed:', error);
          resolve({ success: false, error: 'Upload failed. Please try again.' });
        },
        async () => {
          console.log('File uploaded successfully');
          console.log("File uploaded successfully");
          // Retrieve metadata
          const metadata = await getMetadata(storageRef);
          console.log("Uploaded file size:", metadata.size);
          resolve({ success: true, url: newFileName});
        }
      );
    });
  } catch (error) {
    console.error('Error uploading file:', error);
    return { success: false, error: 'An unexpected error occurred.' };
  }
};
